import { render, staticRenderFns } from "./MembershipSidebar.vue?vue&type=template&id=c8529172&scoped=true"
import script from "./MembershipSidebar.vue?vue&type=script&lang=js"
export * from "./MembershipSidebar.vue?vue&type=script&lang=js"
import style0 from "./MembershipSidebar.vue?vue&type=style&index=0&id=c8529172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8529172",
  null
  
)

export default component.exports